import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authorizedUserGuard } from '@guards/authorized-user.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'screening',
  },
  {
    path: 'profile',
    canActivate: [authorizedUserGuard],
    loadComponent: () => import('@pages/profile/profile.component').then((m) => m.ProfileComponent),
  },
  {
    path: 'sign-in',
    loadComponent: () => import('@pages/sign-in/sign-in.component').then((m) => m.SignInComponent),
  },
  {
    path: 'sign-up',
    loadComponent: () => import('@pages/sign-up/sign-up.component').then((m) => m.SignUpComponent),
  },
  {
    path: 'password-reset',
    loadComponent: () => import('@pages/password-reset/password-reset.component').then((m) => m.PasswordResetComponent),
  },
  {
    path: 'reservation-method',
    loadComponent: () =>
      import('@pages/reservation-method/reservation-method.component').then((m) => m.ReservationMethodComponent),
  },
  {
    path: 'screening',
    loadChildren: () => import('@pages/screening/screening.module').then((m) => m.ScreeningModule),
  },
  {
    path: 'reservation',
    loadChildren: () => import('@pages/reservation/reservation.module').then((m) => m.ReservationModule),
  },
  { path: 'payment', loadChildren: () => import('@pages/payment/payment.module').then((m) => m.PaymentModule) },
  {
    path: 'technical-break',
    loadComponent: () =>
      import('@pages/technical-break/technical-break.component').then((m) => m.TechnicalBreakComponent),
  },
  {
    path: '**',
    loadComponent: () => import('@pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
